var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_15009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24065 2.34619C0.769343 2.95939 0.413961 3.66614 0.207031 4.43393H3.32839L1.24065 2.34619Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7942 4.43391C11.5872 3.66614 11.2318 2.95939 10.7605 2.34619L8.67285 4.43391H11.7942Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.207031 7.56494C0.413984 8.33271 0.769367 9.03946 1.24065 9.65264L3.32832 7.56494H0.207031Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65315 1.2397C9.03995 0.768391 8.33322 0.413008 7.56543 0.206055V3.32739L9.65315 1.2397Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34766 10.7586C2.96085 11.2299 3.66761 11.5853 4.43538 11.7922V8.6709L2.34766 10.7586Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43535 0.206055C3.66759 0.413008 2.96083 0.76839 2.34766 1.23967L4.43535 3.32737V0.206055Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56543 11.7922C8.3332 11.5853 9.03995 11.2299 9.65312 10.7586L7.56543 8.6709V11.7922Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67285 7.56494L10.7605 9.65265C11.2318 9.03948 11.5872 8.33271 11.7942 7.56494H8.67285Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9492 5.2174H6.78265H6.78263V0.0507891C6.52643 0.0174375 6.26524 0 6 0C5.73471 0 5.47357 0.0174375 5.2174 0.0507891V5.21735V5.21737H0.0507891C0.0174375 5.47357 0 5.73476 0 6C0 6.26529 0.0174375 6.52643 0.0507891 6.7826H5.21735H5.21737V11.9492C5.47357 11.9826 5.73471 12 6 12C6.26524 12 6.52643 11.9826 6.7826 11.9492V6.78265V6.78263H11.9492C11.9826 6.52643 12 6.26529 12 6C12 5.73476 11.9826 5.47357 11.9492 5.2174Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56543 7.56545L10.2428 10.2429C10.366 10.1198 10.4834 9.99107 10.5955 9.85767L8.30329 7.56543H7.56543V7.56545Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43524 7.56543H4.4352L1.75781 10.2428C1.88091 10.366 2.0096 10.4834 2.14301 10.5955L4.43524 8.30322V7.56543Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43439 4.4348V4.43475L1.75698 1.75732C1.63384 1.88042 1.51638 2.00911 1.4043 2.14252L3.69655 4.43478H4.43439V4.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56543 4.4349L10.2429 1.75745C10.1198 1.63431 9.99107 1.51684 9.85767 1.40479L7.56543 3.69704V4.4349Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_15009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.301e6918dbdbff7e4763a3d845ce928c.svg";
export { ForwardRef as ReactComponent };